import { css } from 'emotion';

export const root = css`
    margin-bottom: 8px !important;
`;
